<template>
    <div class="ml-2">
        <b-button variant="danger" @click.stop="abrirModal()"
            ><i class="fa fa-refresh"></i> Devolver</b-button
        >
        <encaminhamento-form
            titulo="Devolver Requisição"
            operacao="D"
            :dados="dadosDevolucao"
            :requisicao="requisicao"
            :erros="erros"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            @salvar="devolverRequisicao($event)"
        ></encaminhamento-form>
    </div>
</template>

<script>
import EncaminhamentoForm from './EncaminhamentoForm'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    components: {
        EncaminhamentoForm
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            dadosDevolucao: null
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.obterDadosDevolucao()
        },

        obterDadosDevolucao() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDadosDevolucao(
                this.$route.params.idRequisicao
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.dadosDevolucao = response.data
                    } else {
                        this.erros = [
                            'Erro ao obter dados da devolução da requisição'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
                this.mostrarModal = true
            })
        },

        devolverRequisicao(devolucao) {
            this.$store.dispatch('addRequest')
            devolucao.idRequisicao = this.requisicao.idRequisicao
            RequisicoesServicos.devolver(devolucao).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Requisição devolvida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.mostrarModal = false
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {},

    created() {}
}
</script>
